import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetService } from '../../../../Services/asset.service';
import { NotificationService } from '../../../../Services/notification.service';
import { Asset } from '../../../../Models/asset';
import { HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../Services/auth.service';

@Component({
  selector: 'app-assets',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.css']
})
export class AssetsComponent implements OnInit {

  currentKalakarId!: string | null;
  assignedAssets: Asset[] = [];
  isLoading = true;

  constructor(
    private assetService: AssetService,
    private notificationService: NotificationService,
    private authService:AuthService
  ) {}

  ngOnInit(): void {
    this.currentKalakarId = this.authService.getUserId();
    this.loadAssignedAssets();
  }

  loadAssignedAssets(): void {
    this.isLoading = true;
    const params = new HttpParams().set('kalakar_id', this.currentKalakarId!.toString());
    console.log("kalakar id is", this.currentKalakarId!.toString());

    this.assetService.getAssets(params).subscribe({
      next: (response: any) => {
        this.assignedAssets = response.data || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.notificationService.showError('Could not fetch your assigned assets.', 'API Error');
        this.isLoading = false;
      }
    });
  }

  acknowledgeReceipt(assetId: number | undefined): void {
    if (!assetId) return;

    const payload = {
      receipt_acknowledged_at: new Date().toISOString(),
      issue_reported_at: null // Clear any previously reported issue
    };

    this.assetService.updateAsset(assetId, payload).subscribe({
      next: () => {
        this.notificationService.showSuccess('Receipt Acknowledged!', 'Success');
        this.loadAssignedAssets();
      },
      error: (err) => this.notificationService.showError('Could not update status.', 'API Error')
    });
  }

  /**
   * UPDATED: Now makes an API call to "flag" the asset.
   * @param asset The asset that was not received.
   */
  reportNotReceived(asset: Asset): void {
    if (!asset.id) return;

    // Use asset_name if available, otherwise fallback to name
    const assetName = asset.name || asset.name;
    const message = `You are reporting that you have NOT received the asset: "${assetName}". This will flag the item for admin review. Do you want to continue?`;

    if (confirm(message)) {
      const payload = {
        issue_reported_at: new Date().toISOString()
      };

      this.assetService.updateAsset(asset.id, payload).subscribe({
        next: () => {
          this.notificationService.showWarning(
            'The asset has been flagged for admin review.',
            'Report Sent'
          );
          this.loadAssignedAssets(); // Refresh the list to show the updated status
        },
        error: (err) => {
          this.notificationService.showError('Could not report issue.', 'API Error');
          console.error(err);
        }
      });
    }
  }

  requestReturn(assetId: number | undefined): void {
    if (!assetId) return;

    if (confirm('Are you sure you want to request to return this asset? An admin will need to approve this request.')) {
      const payload = {
        return_requested_at: new Date().toISOString()
      };

      this.assetService.updateAsset(assetId, payload).subscribe({
        next: () => {
          this.notificationService.showSuccess('Return request has been sent.', 'Request Sent');
          this.loadAssignedAssets();
        },
        error: (err) => this.notificationService.showError('Could not send return request.', 'API Error')
      });
    }
  }
}
